import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgBookOpen} from "~/assets/svg/book-open.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmBookOpenIcon: React.FC<IIconBase> = ({
  id,
  size = "sm",
  color = designColors.black,
  strokeWidth = "initial",
  className,
}) => {
  return (
    <SvgBookOpen
      id={id}
      className={cx(
        simpleIconStyles(size),
        commonStyles.color(color),
        commonStyles.strokeWidth(strokeWidth),
        className,
      )}
    />
  );
};
